import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import { MedicoParceiroContext } from "../../../../context/MedicoParceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import MedicoParceiroDeclaration from "../../../components/materialui/MedicoParceiro/termsDeclarations/MedicoParceiroDeclaration";


export default function TermsDeclarationsStep() {

    const { state, dispatch } = useContext(MedicoParceiroContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Termos e Declarações" />

            <Box mt={2}>
                <MedicoParceiroDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    onInputChange={onInputChange} />

            </Box>

        </div>
    );
}